/**
 *
 * @module b-toolkit-core
 */
define('toolkit/b-toolkit/b-toolkit.core', function (require) {
	'use strict';

	var $ = require('jquery'),
		toolkit = require('toolkit/b-toolkit/b-toolkit.context'),
		cache = require('toolkit/b-toolkit/b-toolkit.cache');

	var logLevels = ['debug', 'info', 'warning', 'error'];

	var gid = 0;

	var settings = {
		template: ''
	};

	function _getDataModel($el) {
		var model;
		var value = $el.attr('data-model');

		if (window.__isToolkitDataModel(value)) {
			model = window.__toolkitDataModelDeserialize(value);
		} else {
			try {
				model = JSON.parse(value);
			} catch (err) {
			}
		}

		return model || {};
	}

	function _notEqualData(actual, expected) {
		var key, eVal, aVal, typeOf;

		for (key in expected) {
			aVal = actual[key];
			eVal = expected[key];

			if (eVal !== aVal) {
				typeOf = typeof eVal;

				if (
					(typeOf === 'object') &&
					(typeof aVal === typeOf) &&
					!(aVal instanceof Function)
				) {
					if (_notEqualData(aVal, eVal)) {
						return key;
					}
				}
				else {
					return key;
				}
			}
		}

		return false;
	}

	/**
	 * Метод для установки/получения настроек.
	 * @static
	 * @method
	 * @memberof toolkit
	 * @param  {Object|string}  [options]  Может быть как объектом настроек,
	 * так и строковым ключом
	 * @param  {*}  [value]  Используется только для установки значения
	 * @returns {*}
	 * @memberOf b-toolkit-core#
	 */
	toolkit.setup = function (options, value) {
		if (options === undefined) { // get all settings
			return settings;
		} else {
			if (value !== undefined) { // set setting
				settings[options] = value;
			} else if (typeof options === 'string') { // get setting, options - is a key
				return settings[options];
			} else {
				for (var key in options) { // set bundle of settings
					/* istanbul ignore next */
					if (options.hasOwnProperty(key)) {
						settings[key] = options[key];
					}
				}
			}

			toolkit.initUsingFonts();
		}
	};

	/**
	 * Инициализация шрифтов глобальных
	 *
	 */
	toolkit.initUsingFonts = function () {
		var settings = toolkit.setup();

		if (settings.initUsingFontsDisabled) {
			$(document.body).removeClass('g-default-font g-macintosh-font');
			return;
		}

		$(document.body).addClass('g-default-font');

		if (/macintosh/i.test(navigator.userAgent)) {
			$(document.body).addClass('g-macintosh-font');
		}
	};

	/**
	 *
	 * @desc Функция для получения b-toolkit* объекта из элемента
	 * @deprecated
	 * @param {HTMLElement} el
	 * @param {Object} [opts] опции в конструкторе тулкита
	 * @returns {b-toolkit}
	 * @memberOf b-toolkit-core#
	 */
	function wrap(el, opts) {
		var $el = $(el),
			sel = '.' + this.prototype.bemName,
			item;

		if (!$el.is(sel)) {
			$el = $el.find(sel);

			if(!$el.length){
				return;
			}

			$el = $el.first();
		}

		item = $el.getBlock();
		if(item){
			return item;
		}

		opts = $.extend(opts, {
			el: $el,
			data: _getDataModel($el),
			renderMode: 'replace'
		});

		return new this(opts);
	}

	function extend(name, methods) {
		if (!methods) {
			// TODO: сделать параметр name обязательным и убрать эти проверки.
			if (typeof name === 'string') {
				methods = {};
			} else {
				methods = name || {};
				name = undefined;
			}
		}

		return toolkit.create(name, this, methods);
	}

	/**
	 * Create BEM block class
	 *
	 * @param {String} name
	 * @param {Object} [Parent]
	 * @param {Object} [methods]
	 * @returns {Block}
	 * @memberOf b-toolkit-core#
	 */
	toolkit.create = function (name, Parent, methods) {
		if (!methods) {
			if (typeof Parent === 'object') {
				methods = Parent;
				Parent = undefined;
			} else {
				methods = {};
			}
		}

		if (typeof Parent !== 'function') {
			if (typeof Parent === 'string') {
				Parent = toolkit[Parent];
			} else {
				Parent = toolkit['b-toolkit'];
			}
		}

		function Block(properties) {
			Parent.call(this, properties);
		}

		Block.prototype = Block.fn = Object.create(Parent.prototype);
		Block.prototype.constructor = Block;

		methods.bemName = methods.bemName || name;
		methods.template = methods.template || settings.template;
		methods.templateBlock = methods.templateBlock ||
			settings.templateBlock || methods.bemName;

		$.extend(Block.prototype, methods);

		Block.extend = extend;
		Block.wrap = wrap;

		toolkit[name] = Block;

		return Block;
	};

	function BaseBlock(opts){
		var uniqid,
			node = opts.$el || opts.el,
			$node = $(node),
			block;

		// TODO this.service костыль, который нужен для того чтобы
		// не удалять блок из кеша если кто то хочет для ноды
		// доблять бконтролгруп отдельно
		if(node && !this.service){

			uniqid = $node[0] && $node[0].__toolkit_uniqid;

			if (uniqid) {
				block = cache.get(uniqid);
			}

			if (block) {
				block.destroy();
			}
		}

		this.uniqid = 'toolkit-' + Date.now() + gid++;

		/**
		 * @deprecated since version 0.16.0
		 */
		this.uniqId = this.uniqid;

		$.extend(this, {
			data: {}  // template data
		}, this.defaults, opts);

		// Create event emitter
		var $emitter = $(this);
		$.each({ on: 'bind', off: 'unbind', fire: 'triggerHandler' },
			function (myName, jName){
				this[myName] = function (){
					$emitter[jName].apply($emitter, arguments);
					return	this;
				};
			}.bind(this)
		);

		if( this.boundAll ){
			$.each(this.boundAll, function (i, name){
				this[name] = this[name].bind(this);
			}.bind(this));
		}

		this.setElement(opts.el || opts.$el);

		if (!this.deferredInit) {
			this.init();
		}

		//Удаляем модель из аттрибута после создания блока
		this.$el.removeAttr('data-model');

		if (!this.service) {
			//Добовляем иднтификатор блока, для связи его с кешом
			this.$el.each(function(i,node) {
				node.__toolkit_uniqid = this.uniqid;
			}.bind(this));

			cache.add(this);
		}

	}

	toolkit.create('b-toolkit', BaseBlock, {
		events: {},
		defaults: {},

		eventEmitTo: null,
		eventEmitPrefix: '',

		dirtyCheck: false,
		dataIsChanged: true,

		init: function () {},

		bound: function (fn){
			if( typeof fn === 'string' ){
				fn = this[fn];
			}
			return	fn.bind(this);
		},

		emit: function (name, args){
			var
				prefix	= this.eventEmitPrefix,
				method	= $.camelCase('on-' + (prefix ? prefix + '-' : '') + name),
				event		= $.Event( name.replace(/-/g, '') ),
				emmiter	= this.eventEmitTo || this
				;

			event.target = this;

			if(
				(emmiter[method] === void 0) ||
				(emmiter[method]
					.apply(emmiter, [event].concat(args)) !== false)
			){
				if( !event.isImmediatePropagationStopped() ){
					return emmiter.fire(event, args);
				}
			}
		},

		trigger: function (name, args) {
			this.emit(name, args);
			this.$el.trigger(name, args);
		},

		s: function (selector) {
			if( typeof selector === 'string' && selector.substr(0, 2) === '__' ){
				selector = '.' + this.bemName + selector;
			}
			return	selector;
		},

		$: function (selector){
			return	this.$el.find( this.s(selector) );
		},

		toggleMod: function (mod, state){
			toolkit.toggleMod(this.$el, mod, state);
			return	this;
		},

		getMods: function (){
			return toolkit.getMods(this.$el);
		},

		hasMod: function (mod){
			return toolkit.hasMod(this.$el, mod);
		},

		setElement: function (el){
			if (this.$el) {
				this.undelegateEvents();
			}

			this.$el = el = $(el);
			this.el  = el[0];

			if (this.el) {
				this.delegateEvents();
			}
			return this;
		},

		delegateEvents: function () {
			var _this = this,
				uniqid = _this.uniqid;

			$.each(_this.events, function (name, fn) {
				name = name.trim().split(/\s+/);

				if (name[1]) {
					_this.$el.delegate(name[1], name[0] + '.' + uniqid, _this.bound(fn));
				} else {
					_this.on(name[0] + '.' + uniqid, _this.bound(fn));
				}
			});
		},

		undelegateEvents: function ($el) {
			if ($el) {
				$el.off('.' + this.uniqid);
			}
			else {
				$('body').off('.' + this.uniqid);
				$(document).off('.' + this.uniqid);
				this.$el && this.$el.off('.' + this.uniqid);
			}
		},

		setData: function (data){
			var _data = this.data;

			this.data = data;
			this.dataIsChanged = this.dirtyCheck ? this.dataIsChanged || _notEqualData(_data, data) : true;

			return this;
		},

		extendData: function (data) {
			var _data = this.data,
				res = Object.assign({}, _data, data);

			this.data = res;
			this.dataIsChanged = this.dirtyCheck ? this.dataIsChanged || _notEqualData(_data, res) : true;

			return this;
		},

		getData: function (){
			return	this.data;
		},

		getHtml: function (data){
			var ctx = this.getData(),
				template = this.template || settings.template;

			if( data ){
				ctx = $.extend({}, ctx, data);
			}

			if( this.templateBlock ){
				ctx = {
					block: this.templateBlock,
					params: ctx
				};
			}

			return fest[template](ctx);
		},

		set: function (opts){
			$.extend(this, opts);
			return	this;
		},

		toString: function () {
			return this.getHtml();
		},

		/**
		 * Метод перерисовывает блок, если были изменены его данные
		 * @param data - данные, которые буду использованы при отрисовки
		 * @param inner - признак того, что нужно переинициализировать дочернии блоки
		 * @returns {Block}
		 * @memberOf b-toolkit-core#
		 */
		render: function (data, inner){
			var html, triggerParams;

			if (typeof data === 'boolean') {
				inner = data;
				data = null;
			}

			if (!this.dataIsChanged) {
				return this;
			}

			if (this.dirtyCheck) {
				this.dataIsChanged = false;
			}

			html = this.getHtml(data);

			triggerParams = {
				el: this.$el,
				block: this,
				name: this.bemName,
				template: this.template,
				data: data
			};

			this.emit('before_render', triggerParams);
			$(window).trigger('b-toolkit:before_render', triggerParams);

			var $node = $(html);

			switch (this.renderMode) {
				case 'replace':
					//Выплюнуть ранее созданные дочерние b-toolkit
					this._destroyInner();
					this.$el.replaceWith($node);
					this.setElement($node);
					break;

				case 'append':
					this.$el.append($node);
					this.setElement($node);
					break;

				default:
					//Выплюнуть ранее созданные дочерние b-toolkit
					this._destroyInner();
					this.$el.empty().append($node);
			}

			// Attention: jquery.fest.js & b-toolkit.js
			if (typeof html === 'string' && html.indexOf('data-rb="show"') > -1) {
				this.$('[data-rb="show"]').trigger('rb-show');
			}

			//Не теряем при рендере uniqid блока
			this.$el.each(function(i,node) {
				node.__toolkit_uniqid = this.uniqid;
			}.bind(this));

			if (inner || this.inner) {
				this.blocks = toolkit['b-toolkit'].initInner(this.$el, this.template);
			}

			//Удаляем модель из аттрибута после рендера
			this.$el.removeAttr('data-model');

			this.emit('render', triggerParams);
			this.$el.trigger('b-toolkit:render', triggerParams);

			return this;
		},

		renderTo: function (el, data) {
			this.setElement(el).render(data);
		},

		empty: function() {
			this.$el
				.empty() // clear & clean
			;
		},

		/**
		 * @param {boolean} [ignoreChildren] - игнорировать детей
		 * @param {boolean} [soft] - мягкое удаление, без удаления содержимого
		 * @memberOf b-toolkit-core#
		 */
		destroy: function (ignoreChildren, soft){
			this.off();
			this.undelegateEvents();
			cache.remove(this.uniqid);

			if (!ignoreChildren) {
				this._destroyInner(soft);
			}

			if (this.$el && !soft) {
				this.empty();
			}

			this.$el = this.el = null;
		},

		_destroyInner: function(soft) {
			var child,
				block,
				node;

			if (!this.$el) {
				return;
			}

			child = this.$el.find('[data-bem]').toArray();

			while ((node = child.pop())) {
				block  = $(node).getBlock();
				block && block.destroy(true, soft);
			}
		},

		log: function (level) {
			var data;

			if (!this.logHandler) {
				return;
			}

			if (!logLevels.includes(level)) {
				data = Array.prototype.slice.call(arguments, 0);
				level = 'debug';
			} else {
				data = Array.prototype.slice.call(arguments, 1);
			}

			if (
				(Array.isArray(this.logLevels) && this.logLevels.includes(level)) ||
				($.isPlainObject(this.logLevels) && this.logLevels[level])
			) {
				this.logHandler(level, data);
			}
		},

		/**
		 * Метод инициализирует все вложенные в блок блоки
		 * @returns {*} список проинициализированых блоков
		 * (если на у них определен blockid)
		 * @memberOf b-toolkit-core#
		 */
		initInner: function () {
			return toolkit['b-toolkit'].initInner(this.$el, this.template);
		}
	});

	/**
	 * Метод инициализирует вложенные блоки
	 * @param {JQuery} $container - контейнер
	 *      в котором необходимо проинициализировать вложенные блоки
	 * @param {string} template - имя шаблона
	 *      в контексте которого должен рендерится блока (например pages/lego)
	 * @memberOf b-toolkit-core#
	 */
	toolkit['b-toolkit'].initInner = function ($container, template) {
		var $el, node, nodes, instance,
			ret = [];

		template = template || settings.template;
		nodes = $container.find('[data-bem]').toArray();

		while (node = nodes.pop()) { // jshint ignore:line
			$el = $(node);
			instance = null;

			if (node.__toolkit_uniqid) {
				instance = cache.get(node.__toolkit_uniqid);
			}

			if (!instance) {
				instance = this.initBlock($el, template);
			}

			ret.push(instance);
		}

		return ret;
	};

	toolkit['b-toolkit'].initBlock = function($el, template){
		//fix не читались поля добавленные через data
		var data = {
			uniqid: $el[0].__toolkit_uniqid,
			bem: $el.attr('data-bem'),
			model: _getDataModel($el)
		};

		return this.createBlock($el, data, template, 'replace');
	};

	toolkit['b-toolkit'].setup = toolkit.setup;

	toolkit['b-toolkit'].createBlock = function ($el, data, template, renderMode) {
		var Block = toolkit[data.bem],
			instance = cache.get(data.uniqid);

		if (instance) {
			return instance;
		}

		if (!Block) {
			// TODO показать варнинг о том что не определен data-bem
			return null;
		}

		instance = new Block({
			el: $el,
			template: template,
			renderMode: renderMode,
			data: data.model || {}
		});

		// если включена отложенная инициализация,
		// то нужно вызвать метод .init() т.к. он сам не вызовется,
		// а в текущем методе .init() должен вызыватся всегда
		if(instance.deferredInit) {
			instance.init();
		}

		return instance;
	};

	return toolkit['b-toolkit'];
});
